const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Contact service",
  description: "Welcome to contact service",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Tým obchodu s pneumatikami",
    car: "Tým autosalonů",
    lkw: "Tým nákladních vozidel",
    em_otr: "Tým EM/OTR",
    farm_tractor: "Tým zemědělských traktorů",
    bandag: "Tým Bandag",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
